<template>
  <t-modal @close="$emit('close')">
    <div class="modal-header">Согласие на обработку персональных данных</div>
    <div class="modal-body">
      <p>
        Даю свое согласие на обработку моих персональных данных с использованием средств автоматизации или без использования
        таких средств, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение),
        извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование,
        удаление, уничтожение с целью реализации мною прав на получение образования следующих своих персональных
        данных: фамилия, имя, отчество (при наличии), дата рождения, пол, номер мобильного телефона, адрес электронной почты.
        А также получение информации, связанной с поступлением посредством телефонных звонков, SMS-сообщений, электронных
        писем и иных форм связи.
      </p>
      <a href="https://regulations.tusur.ru/#/documents/261">Политика в отношении обработки персональных данных.</a>
    </div>
    <div class="modal-footer">
      <button class="btn btn--outline-primary" type="button" @click="$emit('close')">
        Ознакомлен
      </button>
    </div>
  </t-modal>
</template>

<script setup>
import { TModal } from '@shared/ui'

defineEmits(['close'])
</script>
